<template>
    <div>
        <AlertModal
                v-if="controller.alertModal != null"
                :controller="controller.alertModal"
        ></AlertModal>
        <ConfirmModal
                v-if="controller.confirmModal != null"
                :controller="controller.confirmModal"
        ></ConfirmModal>
        <LoadingModal
                v-if="controller.loadingModal != null"
                :controller="controller.loadingModal"
        ></LoadingModal>
        <PdpaModal
                v-if="controller.pdpaModal != null"
                :controller="controller.pdpaModal"
        ></PdpaModal>
        <ConfirmRedeemModal
                v-if="controller.confirmRedeemModal != null"
                :controller="controller.confirmRedeemModal"
        ></ConfirmRedeemModal>
        <SerialModal
                v-if="controller.serialModal != null"
                :controller="controller.serialModal"
        ></SerialModal>
        <DrawDeliveryModal
                v-if="controller.drawDeliveryModal != null"
                :controller="controller.drawDeliveryModal"
        ></DrawDeliveryModal>
        <ShippingAddressModal
                v-if="controller.shippingAddressModal != null"
                :controller="controller.shippingAddressModal"
        ></ShippingAddressModal>
        <ShareModal
                v-if="controller.shareModal != null"
                :controller="controller.shareModal"
        ></ShareModal>
        <AddAddressModal
                v-if="controller.addAddressModal != null"
                :controller="controller.addAddressModal"
        ></AddAddressModal>
        <EditAddressModal
                v-if="controller.editAddressModal != null"
                :controller="controller.editAddressModal"
        ></EditAddressModal>
        <ListAddressModal
                v-if="controller.listAddressModal != null"
                :controller="controller.listAddressModal"
        ></ListAddressModal>
        <AddTaxAddressModal
                v-if="controller.addTaxAddressModal != null"
                :controller="controller.addTaxAddressModal"
        ></AddTaxAddressModal>
        <EditTaxAddressModal
                v-if="controller.editTaxAddressModal != null"
                :controller="controller.editTaxAddressModal"
        ></EditTaxAddressModal>
        <ListTaxAddressModal
                v-if="controller.listTaxAddressModal != null"
                :controller="controller.listTaxAddressModal"
        ></ListTaxAddressModal>
        <CancelTermsAndPrivacyModal
                v-if="controller.cancelTermsAndPrivacyModal != null"
                :controller="controller.cancelTermsAndPrivacyModal"
        ></CancelTermsAndPrivacyModal>
        <ChangeMobileNumberModal
                v-if="controller.changeMobileNumberModal != null"
                :controller="controller.changeMobileNumberModal"
        >
        </ChangeMobileNumberModal>
        <FlashsaleModal
                v-if="controller.flashSaleModal != null"
                :controller="controller.flashSaleModal"
        ></FlashsaleModal>
        <BadgeAlertModal
                v-if="controller.badgeAlertModal != null"
                :controller="controller.badgeAlertModal"
        >
        </BadgeAlertModal>

        <ConfirmSurpriseModal
                v-if="controller.confirmSurpriseModal != null"
                :controller="controller.confirmSurpriseModal"
        >
        </ConfirmSurpriseModal>
        <AlertConditionModal
                v-if="controller.alertConditionModal != null"
                :controller="controller.alertConditionModal"
        >
        </AlertConditionModal>
        <FGFModal
                v-if="controller.fgfModal != null"
                :controller="controller.fgfModal"
        ></FGFModal>
        <FGFShareModal
                v-if="controller.sharefgfModal != null"
                :controller="controller.sharefgfModal"
        ></FGFShareModal>
        <PromocodeModal
                v-if="controller.promocodeModal != null"
                :controller="controller.promocodeModal"
        ></PromocodeModal>
        <PromocodeSuccessModal
                v-if="controller.promocodeSuccessModal != null"
                :controller="controller.promocodeSuccessModal"
        ></PromocodeSuccessModal>
        <VerifyCodeModal
                v-if="controller.verifyCodeModal != null"
                :controller="controller.verifyCodeModal"
        ></VerifyCodeModal>
    </div>
</template>
<script>
//generic
import AlertModal from './Generic/AlertModal/AlertModal.vue';
import ConfirmModal from "./Generic/ConfirmModal/ConfirmModal.vue";
import LoadingModal from './Generic/LoadingModal/LoadingModal.vue';
//authen
import PdpaModal from './Authen/PdpaModal/PdpaModal.vue';
//redeem
import ConfirmRedeemModal from '@/module/Detail/modal/ConfirmRedeemModal/ConfirmRedeemModal.vue';
import SerialModal from '@/module/Detail/modal/SerialModal/SerialModal.vue';
import DrawDeliveryModal from '@/module/Detail/modal/DrawDeliveryModal/DrawDeliveryModal.vue';
import ShippingAddressModal from '@/module/Detail/modal/ShippingAddressModal/ShippingAddressModal.vue';
import ShareModal from '@/module/Detail/modal/ShareModal/ShareModal.vue';
//address
import AddAddressModal from '@/module/Address/DeliveryAddress/modal/AddAddressModal/AddAddressModal.vue';
import EditAddressModal from '@/module/Address/DeliveryAddress/modal/EditAddressModal/EditAddressModal.vue';
import ListAddressModal from '@/module/Address/DeliveryAddress/modal/ListAddressModal/ListAddressModal.vue';
import AddTaxAddressModal from '@/module/Address/TaxAddress/modal/AddTaxAddressModal/AddTaxAddressModal.vue';
import EditTaxAddressModal from '@/module/Address/TaxAddress/modal/EditTaxAddressModal/EditTaxAddressModal.vue';
import ListTaxAddressModal from '@/module/Address/TaxAddress/modal/ListTaxAddressModal/ListTaxAddressModal.vue';
//pdpa
import CancelTermsAndPrivacyModal from '@/module/Static/Pdpa/modal/CancelTermsAndPrivacyModal/CancelTermsAndPrivacyModal.vue';
// profile
import ChangeMobileNumberModal from '@/module/Profile/modal/ChangeMobileNumber/ChangeMobileNumberModal.vue';
import FlashsaleModal from "../../module/Home/component/modal/FlashsaleModal.vue";
import BadgeAlertModal from "../../module/Badge/modal/BadgeAlretModal.vue";
// Badge
import ConfirmSurpriseModal from "@/module/SurpriseBox/modal/ConfirmSurpriseModal.vue";
import AlertConditionModal from "@/module/SurpriseBox/modal/AlertConditionModal.vue";

import FGFModal from '../../module/FriendGetFriend/modal/FGFModal/FGFModal.vue';
import FGFShareModal from '../../module/FriendGetFriend/modal/ShareModal/ShareModal.vue';

import PromocodeModal from '@/module/Promocode/modal/PromocodeModal/PromocodeModal.vue';
import PromocodeSuccessModal from '@/module/Promocode/modal/ConfirmModal/PromocodeSuccessModal.vue';

import VerifyCodeModal from '@/module/SurpriseBox/modal/VerifyCodeModal/VerifyCodeModal.vue';

export default {
    name: 'ModalMaster',
    components: {
    AlertModal,
    ConfirmModal,
    LoadingModal,
    PdpaModal,
    ConfirmRedeemModal,
    SerialModal,
    ShippingAddressModal,
    ShareModal,
    DrawDeliveryModal,
    AddAddressModal,
    EditAddressModal,
    ListAddressModal,
    AddTaxAddressModal,
    EditTaxAddressModal,
    ListTaxAddressModal,
    CancelTermsAndPrivacyModal,
    ChangeMobileNumberModal,
    FlashsaleModal,
    BadgeAlertModal,
    ConfirmSurpriseModal,
    AlertConditionModal,
    FGFModal,
    FGFShareModal,
    PromocodeModal,
    PromocodeSuccessModal,
    VerifyCodeModal
},
    props: {
        controller: {
            type: Object,
            required: true,
        },
    },
}
</script>
